import { Link, useLocation } from "react-router-dom";
import { BsArrowRight } from "react-icons/bs";
import Breadcrumb from "./Breadcrumb";

export default function Banner() {
  const location = useLocation();
  const isService = location.pathname === "/service";
  const isTraining = location.pathname === "/training";
  const isCourse = location.pathname === "/courses";
  // const isTraining = lastSegment === "training";

  const DecorativeElements = () => (
    <>
      <div className="absolute bottom-0 right-10 w-0 h-0 border-l-[40px] border-r-[40px] border-b-[70px] border-l-transparent border-r-transparent border-b-white opacity-20"></div>
      <div className="absolute right-20 -top-10 w-48 h-48 bg-white rounded-full blur-2xl opacity-50 transform -translate-x-1/2 -translate-y-1/2"></div>
    </>
  );

  //  Custom Banner for /training
  if (isService) {
    return (
      <div className="theme-background text-white text-left py-12 px-4 relative">
        <DecorativeElements />
        <section className="container">
          <Breadcrumb />
          <h1 className="">Custom Software Development</h1>
          <div className="w-1/2">
            <h3>Built for Startups, Trusted by Enterprises</h3>
            <p>
              Scalable APIs. Production-ready systems. Cloud-native apps
              tailored for real business needs — all built by backend engineers
              who think in systems.
            </p>
          </div>
          <div className="mt-6 flex  gap-4 flex-wrap">
            <Link
              to="mailto:enginuity.system@gmail.com"
              className="btn-primary"
            >
              Schedule a Free Consultation
            </Link>
            {/* <Link to="#" className="btn-outline">
               View Our Work
            </Link> */}
          </div>
        </section>
      </div>
    );
  }

  if (isTraining) {
    return (
      <div className="theme-background text-white text-left py-12 px-4 relative">
        <DecorativeElements />
        <div className="container relative z-10">
          <Breadcrumb />
          <h1>
            Career-Driven Professional Diploma Program to Become a Backend Engineer Specialist – For CSE/Non-CSE, Diploma & HSC Students!
          </h1>
          <span className="lg:text-2xl text-white font-extrabold italic  bg-clip-text drop-shadow-md animate-pulse">
            Industry-Focused Backend Engineering Professional Training with Real-World
            Projects
          </span>


          <div className="py-2">
            <p className="text-base sm:text-lg md:text-xl font-bold">
              Training Fee:{' '}
              <span className="text-green-400">25,000 Tk</span>
            </p>
            {/* <p className="line-through text-gray-400 text-sm sm:text-base md:text-lg font-semibold">
              Regular Price: 25,000 Tk
            </p>
            <p className="text-green-500 text-base sm:text-lg font-semibold">You Saved 58%</p> */}
          </div>

          <div className="space-y-1">
            <h4 className="text-sm sm:text-base md:text-lg font-semibold">
              Duration: 12 Months (1 Year)
            </h4>
            <h4 className="text-sm sm:text-base md:text-lg font-semibold">
              Three Installment Facilities | Payment via Bank / Bkash | Money-Back Guarantee
            </h4>
            <h4 className="text-red-400 text-sm sm:text-base md:text-lg font-bold">
              Seats Limited – Only 20 Students 
            </h4>
            {/* <div className="rounded-xl shadow-md max-w-3xl text-left">
              <p className="text-xl font-semibold">
                <span className="">Batch 02</span> |
                <span className="ml-2">Admission Last Date: <strong>30 August, 2025</strong></span>
              </p>
            </div> */}
            {/* <h4 className="text-red-400 text-sm sm:text-base md:text-lg font-bold">
              Admission Last Date August 30, 2025
            </h4> */}
          </div>
          {/* <div className="mt-6 flex flex-wrap">
            <Link
              to="https://forms.gle/hnArxno6AadTZxYW6"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary">
              <span className="font-semibold">Register Now</span>
              <BsArrowRight className="w-6 h-6" />
            </Link>
          </div> */}
          <div className="mt-6 flex flex-wrap">
            <Link
              to="/contact"
              // target="_blank"
              rel="noopener noreferrer"
              className="btn-primary">
              <span className="font-semibold">Cantact Now</span>
              <BsArrowRight className="w-6 h-6" />
            </Link>
          </div> 
        </div>
      </div>
    );
  }

  //  Default Banner for all other pages
  return (
    <div className="theme-background text-white text-left py-20 px-4 relative">
      <DecorativeElements />
      <div className="max-w-7xl mx-auto relative z-10">
        <Breadcrumb />
        <h1 className="p-0">Enginuity System</h1>
        <h2 className="p-0">
          Empowering Engineers. Building Solutions.
        </h2>
        {isCourse ? (
        <>
            <p className="p-0">
              Master Backend Development, Software Engineering, Cloud, and DevOps through hands-on training and real-world production projects.
            </p>
            <div className="flex gap-3 font-bold mt-2">
              <p>Educational Training for Non-CSE Students | Learn by building. Deploy like a pro</p>
            </div>
        </>
        ) : (
         <>
              <p className="p-0">
                Learn backend development, software engineering, cloud, and DevOps —
                while we also build scalable software solutions for real-world impact
              </p>
              <div className="flex gap-3 font-bold mt-2">
                <p>Educational Training for Non-CSE Students |
                  Custom Web & Backend Development</p>
              </div>
         </>
        )}
      </div>
    </div>
  );
  
}
